import * as React from "react";
import styled from "styled-components";
import welcome from '../../assets/welcome.png';
import Modal from '@mui/material/Modal'; // Importing Modal from Material-UI
import share from '../../assets/share.png';
import welcome_cat1 from '../../assets/welcome-cat1.png';
import welcome_cat2 from '../../assets/welcome-cat2.png';
import welcome_background from '../../assets/welcome-background.png'
import { profileIcon, spoeltLogo } from '../../assets/images';

const socialMediaData = [
  {
    icon: profileIcon,
    handle: "@im_spoelt",
  },
];

export function Welcome() {
  const [open, setOpen] = React.useState(true); // State to control modal visibility

  const handleClose = () => {
    setOpen(false); // Function to close the modal
  };

  const handleShare = (platform) => {
    const url = "https://spoelt.me"; // Replace with the URL you want to share
    const message = `We curate unmatchable deals exclusively for our community members, with a priority on 'Authentic' products and 'Lowest' prices.
      
    Join us to 'Never pay retail price again, Period.'`; 
    if (platform === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)} ${encodeURIComponent(url)}`, '_blank');
    } else if (platform === 'instagram') {
      // Instagram sharing is limited; typically, you can only share to stories via a link
      window.open(`https://www.instagram.com/?url=${encodeURIComponent(url)}`, '_blank');
    }
  };

  return (
    <MainContainer style={{ backgroundColor:  '#e9fe53' }}>
      <HeroSection>
        <HeroLogo src={spoeltLogo} alt="Spoelt logo" />
      </HeroSection>
      <HeroText>Coming soon</HeroText>
      <DescriptionText>
        We're working on onboarding more like minded users. We'll notify you as
        soon as the subscriptions are open and the products are curated as per
        your lists.
      </DescriptionText>
      <ProductImage src={welcome} alt="Product preview" />
      <RegistrationText>
        We are currently accepting only [50K users registrations]
      </RegistrationText>
      <RegistrationSubtext>
        Post this, it will be on an invite only basis!
      </RegistrationSubtext>

      {/* Modal for welcome message */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="welcome-modal-title"
        aria-describedby="welcome-modal-description"
      >
        <ModalContent>
          <CloseButton onClick={handleClose}>Close ✖</CloseButton>
          <HeroText>Welcome to</HeroText>
          <HeroLogo src={spoeltLogo} alt="Spoelt logo" />
          <WelcomeText>
            We're working on onboarding more like minded users. We'll notify you as <br/>
            soon as the subscriptions are open and the products are curated as per
            your lists.
          </WelcomeText>
          
          <CatImagesContainer>
            <CatImageLeft src={welcome_cat1} alt="Welcome Cat 1" />
            <ShareImage 
              style={{ marginTop: '-30px', marginBottom: '30px' }} 
              src={share} 
              alt="Share"  
              onClick={() => handleShare('whatsapp')} // Share via WhatsApp
            />
            <CatImageRight src={welcome_cat2} alt="Welcome Cat 2" />
           {/*  <ShareImage 
              style={{ marginTop: '-30px', marginBottom: '30px' }} 
              src={share} 
              alt="Share"  
              onClick={() => handleShare('instagram')} // Share via Instagram
            /> */}
          </CatImagesContainer>
        </ModalContent>
      </Modal>

      <Footer>
        <SocialMediaSection>
          <SocialMediaText>Follow us on our socials:</SocialMediaText>
          {socialMediaData.map((item, index) => (
            <SocialMediaLink key={index}>
              <SocialMediaIcon src={item.icon} alt="Social media icon" />
              <SocialMediaHandle>{item.handle}</SocialMediaHandle>
            </SocialMediaLink>
          ))}
        </SocialMediaSection>
        <CopyrightText>
          Copyright © 2024. SPOELT. All rights reserved
        </CopyrightText>
      </Footer>
    </MainContainer>
  );
}

const MainContainer = styled.main`
  background-color: #e9fe53;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  padding: 80px;
  height: 100vh; /* Ensure the footer stays at the bottom */
  position: relative; /* For positioning the footer */
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;

const HeroSection = styled.section`
  display: flex;
  margin-top: 7px;
  gap: 20px;
  justify-content: space-between;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    font-size: 40px;
    justify-content: center;
  }
`;

const HeroText = styled.div`
  font-family: Inter, sans-serif;
   font-size: 80px;
  color: #202023;
  font-weight: 800;
  line-height: 108%;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 50px;
    margin-top: 20px;
  }
`;

const HeroLogo = styled.img`
  aspect-ratio: 4;
  object-fit: auto;
  object-position: center;
  width: 332px;
  align-self: start;
  margin-top: 8px;
  @media (max-width: 991px) {
    width: 220px;
  }
`;

const DescriptionText = styled.p`
  color: #202023;
  text-align: center;
  letter-spacing: -0.28px;
  margin-top: 27px;
  width: 600px;
  font: 14px/18px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
const WelcomeText = styled.div`
  color: #202023;
  letter-spacing: -0.28px;
  margin:30px;
  margin-right:40px;
  margin-left:40px;
  text-align: center;

  font: 14px/18px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ProductImage = styled.img`
  aspect-ratio: 3.23;
  object-fit: auto;
  object-position: center;
  width: 586px;
  //border: 1px solid rgba(32, 32, 35, 1);
  margin-top: 33px;
  max-width: 100%;
`;
const ShareImage = styled.img`
 // aspect-ratio: 3.23;
  //object-fit: auto;
  object-position: center;
  width: 30%;
  //border: 1px solid rgba(32, 32, 35, 1);
  //margin-top: 50px;
  max-width: 100%;
  cursor: pointer;
`;
const RegistrationText = styled.h2`
  color: #202023;
  text-align: center;
  margin-top: 23px;
  font: 800 20px/108% Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const RegistrationSubtext = styled.p`
  color: #202023;
  text-align: center;
  letter-spacing: -0.28px;
  margin-top: 12px;
  font: 14px/130% Metrophobic, sans-serif;
`;

const Footer = styled.footer`
  position: absolute; /* Positioning the footer at the bottom */
  bottom: 0; /* Aligning it to the bottom */
  left: 0;
  right: 0;
  display: flex;
  gap: 20px;
  font-size: 12px;
  justify-content: space-between; /* Adjusted to space between elements */
  padding: 20px; /* Added padding for better spacing */
  background-color: #e9fe53; /* Ensure footer has a background */
  @media (max-width: 991px) {
    flex-wrap: wrap;
    justify-content: center;

  }
`;

const SocialMediaSection = styled.section`
  display: flex;
  gap: 9px;
  color: #202023;
  letter-spacing: -0.24px;
  line-height: 130%;
`;

const SocialMediaText = styled.div`
  font-family: Metrophobic, sans-serif;
  text-transform: uppercase;
`;

const SocialMediaLink = styled.a`
  background-color: #e9fe53;
  display: flex;
  gap: 5px;
  white-space: nowrap;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const SocialMediaIcon = styled.img`
  aspect-ratio: 1;
  object-fit: auto;
  object-position: center;
  width: 12px;
  margin: auto 0;
`;

const SocialMediaHandle = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const CopyrightText = styled.div`
  color: var(--Gray-3, #828282);
  font-family: Metrophobic, sans-serif;
  flex-grow: 1;
  flex-basis: auto;
  text-align: right; /* Align text to the right */
  @media (max-width: 991px) {
    margin-top: 10px;
    align-self: center;
    text-align: center;
  }
`;

const ModalContent = styled.div`
  background-color: white;
  background-image: url(${welcome_background}); /* Added background image */
  background-size: cover; /* Cover the entire modal */
  background-position: bottom; /* Position the background at the bottom */
  margin-top:180px;
  margin-left:20%;
  margin-right:20%;
  padding-top:50px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  outline: none;
  text-align: center;
  align-items: center;
  position: relative; /* For positioning the close button */
`;

const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  color: #202023;
`;

const CatImagesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  width: 100%;
`;

const CatImageLeft = styled.img`
  width: 20%; /* Adjust as needed */
  object-fit: contain;
`;

const CatImageRight = styled.img`
  width: 20%; /* Adjust as needed */
  object-fit: contain;
`;